var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrivals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.26 3.92H9.927a.4.4 0 000 .8h1.333a.927.927 0 01.927.927v6.093a.926.926 0 01-.927.927H4.394a.927.927 0 01-.927-.927V5.647a.927.927 0 01.927-.927h1.333a.4.4 0 100-.8H4.394a1.727 1.727 0 00-1.727 1.727v6.093a1.727 1.727 0 001.727 1.727h6.866a1.734 1.734 0 001.727-1.727V5.647A1.733 1.733 0 0011.26 3.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72 7.08a.407.407 0 000 .567L7.534 9.46a.4.4 0 00.44.09.373.373 0 00.126-.09l1.827-1.827a.393.393 0 000-.566.407.407 0 00-.567 0l-1.133 1.14V2.4a.4.4 0 10-.8 0v5.82l-1.14-1.14a.407.407 0 00-.567 0z"
  })));
}
export default SvgArrivals;